import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const PolFormulaForm = () => {
  const rsrc = useRsrc();
  const { entityObj } = useEntityMgr();
  const [filterId, setFilterId] = useState();

  // PolFormula only carries polId, not filterId, so the owning Policy's Filter has to be looked up separately
  useEffect(() => {
    if (!entityObj?.polId) return;
    rsrc.rows('gp', 'POL', { expr: ExprUtils.whereParams('id', entityObj.polId) }).then((rows) => {
      setFilterId(rows[0]?.filterId);
    });
  }, [entityObj?.polId, rsrc]);

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.incDataSrcId.expr = ExprUtils.whereParams('filterId', filterId);
  };

  return <EntityForm key={filterId} augFieldDefs={augFieldDefs} />;
};
